import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import fb from "@bd-core/firebase";
import GameLogic from "@bd-core/game-logic";

export const ResultPhone = () => {
    const isResultPhone = $("#page-result-phone").length > 0;
    if (!isResultPhone) return false;

    bdjs.hideLoading();

    GameLogic.listenGameProgressChanged();

    //----------------------------------------------------------------------- Initialize Firebase
    try {
        fb.initializeGame();
    } catch (e) {
        console.error(e);
    }

    const onInit = () => {
        const $popup = $(".js-game-over-mobile-popup");

        setTimeout(() => {
            $popup.removeClass("is-open");
        }, 3500);
    };

    // Check if the user is on an iOS or Mac device and add "is-ios" class to "is-your-team" rows
    const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.userAgent.includes("Macintosh") && "ontouchend" in document);

    if (isIOS) {
        $(".mobile__result-leaderboard-table-row.is-your-team").addClass(
            "is-ios",
        );
    }

    onInit();
};
